import { useContext, useEffect, useMemo } from 'react';

import { ContextFormFieldTime } from '@bambi/component-library/src/components/forms/context/ContextFormFieldTime';
import { get, useFormContext, useWatch } from 'react-hook-form';

import { DynamicFieldNameRootContext } from 'src/features/add-trip/TripDetails/DynamicFieldNameRootContext';

import { isAssignmentStartTimeBeforeEndTime } from '../AssignmentManagementForm/AssignmentManagementFormStep1/validations';

export function AssignmentTimeInputs() {
  const { getValues, clearErrors, setError } = useFormContext();
  const fieldNameRoot = useContext(DynamicFieldNameRootContext);

  const startFieldName = useMemo(
    () => `${fieldNameRoot}.start`,
    [fieldNameRoot]
  );
  const endFieldName = useMemo(() => `${fieldNameRoot}.end`, [fieldNameRoot]);

  const startValue = useWatch({ name: startFieldName });
  const endValue = useWatch({ name: endFieldName });

  useEffect(() => {
    if (!startValue || !endValue) {
      return;
    }

    const currentFormValues = getValues();
    const assignment = get(currentFormValues, fieldNameRoot);

    if (isAssignmentStartTimeBeforeEndTime(assignment)) {
      clearErrors(startFieldName);
      clearErrors(endFieldName);
    } else {
      setError(
        startFieldName,
        {
          type: 'manual',
          message: 'Must be before end time',
        },
        {
          shouldFocus: false,
        }
      );
      setError(
        endFieldName,
        {
          type: 'manual',
          message: 'Must be after start time',
        },
        {
          shouldFocus: false,
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startValue, endValue, startFieldName, endFieldName]);

  return (
    <div className="flex items-center justify-between gap-x-4 whitespace-nowrap">
      <ContextFormFieldTime
        fieldPath={startFieldName}
        rules={{
          required: 'Start is required',
        }}
      />
      <div className="text-xl"> - </div>
      <ContextFormFieldTime
        fieldPath={endFieldName}
        rules={{
          required: 'End time is required',
        }}
      />
    </div>
  );
}
